import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {BenefitDTO} from '../models/BenefitDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {BankAccountDTO} from '../models/BankAccountDTO';

@Injectable({
  providedIn: 'root'
})
export class BankAccountService {
  private url = environment.baseUrl + '/bank-account';

  constructor(private httpClient: HttpClient) {
  }

  getListOfBankAccounts(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<BankAccountDTO>> {
    return this.httpClient.post<PagedResponseDTO<BankAccountDTO>>(this.url + '/filter', pagedRequestDTO);
  }
}
